import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-section',
  templateUrl: './reports-section.component.html',
  styleUrls: ['./reports-section.component.scss']
})
export class ReportsSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
